import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { SettingType, CodeBlock, BlockType } from '@appblocks/codegeneration/types';

export default class LUISItemOption extends BaseFeature {
    constructor() {
        super();
        this.name = 'Dropdown Option';
        this.id = 'luis_item_option';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'LABEL',
                name: 'Option Label',
                settingType: SettingType.STRING,
                required: true,
                default: 'OPTION_LABEL',
            },
            {
                id: 'VALUE',
                name: 'Option Value',
                settingType: SettingType.STRING,
                required: true,
                default: '0',
            },
        ]);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        blocks.push({
            location: 'sdf.xtxt',
            blockType: BlockType.CODE,
            template: `${this.getSettingValue('LABEL')}/${this.getSettingValue('VALUE')}`,
        });

        blocks.push({
            location: 'menu.xtxt',
            blockType: BlockType.CODE,
            template: `${this.getSettingValue('VALUE')}-${this.getSettingValue('LABEL')}`,
        });

        return blocks;
    }
}
